module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e1711191"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c1_r1"
    }
  }, [_vm._v("Cover Page")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c4_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c5_r1"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1791"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c8_r1#d6e1818",
      "id": "d14e99"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e14101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c9_r1#d6e188617",
      "id": "d14e102"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e26911"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c10_r1#d6e336326",
      "id": "d14e105"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e40841"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c11_r1#d6e514636",
      "id": "d14e108"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e56661"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c12_r1#d6e690547",
      "id": "d14e111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e75161"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c13_r1#d6e915059",
      "id": "d14e114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e93781"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c14_r1#d6e1148971",
      "id": "d14e117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e110571"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c15_r1#d6e1354182",
      "id": "d14e120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e133891"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c16_r1#d6e1658398",
      "id": "d14e123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e162051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c17_r1#d6e20093117",
      "id": "d14e126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e189531"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c18_r1#d6e23819136",
      "id": "d14e130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e226991"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c19_r1#d6e28519161",
      "id": "d14e133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e247701"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c20_r1#d6e31115175",
      "id": "d14e136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e266111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c21_r1#d6e33367187",
      "id": "d14e139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e32101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c22_r1#d6e37173206",
      "id": "d14e142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e320001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c23_r1#d6e40531223",
      "id": "d14e145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e343941"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c24_r1#d6e43807240",
      "id": "d14e148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e369311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c25_r1#d6e47129257",
      "id": "d14e151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e393301"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c26_r1#d6e50443274",
      "id": "d14e154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e416951"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c27_r1#d6e53621290",
      "id": "d14e157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e437061"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c28_r1#d6e56485304",
      "id": "d14e160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e450491"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c29_r1#d6e58148313",
      "id": "d14e164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e471521"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c30_r1#d6e60789328",
      "id": "d14e167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e482851"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pawe_9781569477786_epub_c31_r1#d6e62165336",
      "id": "d14e170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a9ec04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pawe_9781569477786_epub_c7_r1.vue
// module id = 75
// module chunks = 0